import { Frame } from "@/components/site/Frame";
import { Reveal } from "@/components/site/Motion";

const F = ({ m, className = "" }) => <Frame {...m} className={className} />;

const LAYOUTS = {
  full: (media) => <F m={media[0]} />,
  pair: (media) => (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:gap-8">{media.map((m) => <F key={m.desc} m={m} />)}</div>
  ),
  trio: (media) => (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-3 lg:gap-8">{media.map((m) => <F key={m.desc} m={m} />)}</div>
  ),
  process: (media) => (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">{media.map((m) => <F key={m.desc} m={m} />)}</div>
  ),
  asym: (media) => (
    <div className="grid grid-cols-1 items-end gap-6 md:grid-cols-12 lg:gap-8">
      <div className="md:col-span-7"><F m={media[0]} /></div>
      <div className="md:col-span-4 md:col-start-9"><F m={media[1]} /></div>
    </div>
  ),
  stack: (media) => (
    <div className="space-y-6 lg:space-y-8">
      <F m={media[0]} />
      {LAYOUTS.pair(media.slice(1))}
    </div>
  ),
  stack4: (media) => (
    <div className="space-y-6 lg:space-y-8">
      <F m={media[0]} />
      {LAYOUTS.process(media.slice(1))}
    </div>
  ),
  duo: (media) => (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-12 lg:gap-8">
      <div className="md:col-span-5 md:col-start-2"><F m={media[0]} /></div>
      <div className="md:col-span-5 md:col-start-7 md:mt-32"><F m={media[1]} /></div>
    </div>
  ),
  stack2: (media) => (
    <div className="space-y-6 lg:space-y-8">
      <F m={media[0]} />
      <F m={media[1]} />
      {LAYOUTS.pair(media.slice(2))}
    </div>
  ),
  editions: (media) => (
    <div className="space-y-6 lg:space-y-8">
      <F m={media[0]} />
      {LAYOUTS.pair(media.slice(1, 3))}
      <div className="pt-6 lg:pt-16">{LAYOUTS.duo(media.slice(3, 5))}</div>
    </div>
  ),
  stack3: (media) => (
    <div className="space-y-6 lg:space-y-8">
      <F m={media[0]} />
      {LAYOUTS.trio(media.slice(1))}
    </div>
  ),
};

export const CaseSection = ({ section: s, index }) => (
  <section id={s.id} data-testid={`case-section-${s.id}`} aria-labelledby={`h-${s.id}`} className="px-6 py-16 lg:px-12 lg:py-28">
    <div className="grid grid-cols-1 gap-6 border-t border-ink/15 pt-6 md:grid-cols-12 md:gap-10">
      <div className="md:col-span-4">
        <div className="md:sticky md:top-24">
          <span className="label text-mute">{String(index + 1).padStart(2, "0")}</span>
          <h2 id={`h-${s.id}`} className="mt-3 font-display text-3xl font-medium tracking-[-0.04em] lg:text-5xl">{s.title}</h2>
        </div>
      </div>
      <Reveal className="space-y-5 md:col-span-7 md:col-start-6">
        {s.statement && <p className="font-display text-3xl font-medium leading-[1.08] tracking-[-0.035em] lg:text-[3.25rem]">{s.statement}</p>}
        {s.body.map((b) => (
          <p key={b} className={`text-lg leading-relaxed lg:text-xl ${b.startsWith("[Placeholder") ? "text-mute" : ""}`}>{b}</p>
        ))}
      </Reveal>
    </div>
    {s.media?.length > 0 && (
      <Reveal className="mt-14 lg:mt-20">{LAYOUTS[s.layout || "full"](s.media)}</Reveal>
    )}
  </section>
);
